import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, onValue, update, get } from "firebase/database";

export default function AdminAssign() {
  const [teams, setTeams] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [teamId, setTeamId] = useState("");
  const [roomId, setRoomId] = useState("");
  const [tables, setTables] = useState([]);
  const [tableId, setTableId] = useState("");

  useEffect(() => {
    const offT = onValue(ref(db, "teams"), (snap) => {
      const v = snap.val() || {};
      const rows = Object.entries(v).map(([id,t]) => ({ id, ...t }));
      setTeams(rows);
    });
    const offR = onValue(ref(db, "rooms"), (snap) => {
      const v = snap.val() || {};
      const rows = Object.entries(v).map(([id,r]) => ({ id, ...r }));
      setRooms(rows);
    });
    return () => { offT(); offR(); };
  }, []);

  useEffect(() => {
    if (!roomId) { setTables([]); setTableId(""); return; }
    const r = rooms.find(x => x.id === roomId);
    if (!r?.t) { setTables([]); setTableId(""); return; }
    const free = Object.keys(r.t).filter(k => r.t[k]?.o !== 1);
    setTables(free);
    setTableId(free[0] || "");
  }, [roomId, rooms]);

  async function assign() {
    if (!teamId || !roomId || !tableId) { alert("Pick team, room, table."); return; }

    // if previously assigned, free old seat
    const tSnap = await get(ref(db, `teams/${teamId}`));
    const t = tSnap.val();
    const up = {};
    if (t?.room && t?.tb) {
      up[`rooms/${t.room}/t/${t.tb}/o`] = 0;
      up[`rooms/${t.room}/t/${t.tb}/r`] = null;
    }

    // set new seat
    up[`rooms/${roomId}/t/${tableId}/o`] = 1;
    up[`rooms/${roomId}/t/${tableId}/r`] = teamId;
    up[`teams/${teamId}/room`] = roomId;
    up[`teams/${teamId}/tb`] = tableId;
    await update(ref(db), up);
    alert("Assigned.");
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin — Assign Seats to Teams</h1>

      <div className="bg-white rounded-2xl shadow p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <select className="p-3 border rounded-xl" value={teamId} onChange={e=>setTeamId(e.target.value)}>
            <option value="">Select Team</option>
            {teams.map(t => <option key={t.id} value={t.id}>{t.n} ({t.id})</option>)}
          </select>

          <select className="p-3 border rounded-xl" value={roomId} onChange={e=>setRoomId(e.target.value)}>
            <option value="">Select Room</option>
            {rooms.map(r => <option key={r.id} value={r.id}>{r.n}</option>)}
          </select>

          <select className="p-3 border rounded-xl" value={tableId} onChange={e=>setTableId(e.target.value)} disabled={!roomId}>
            <option value="">{roomId ? "Select Table" : "Pick room first"}</option>
            {tables.map(t => <option key={t} value={t}>Table {t}</option>)}
          </select>
        </div>

        <button onClick={assign} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Assign Seat</button>
      </div>
    </div>
  );
}
